import axios from "axios";
import logo from "./logo.svg";
import RouterIndex from "./routes/RouterIndex";
// import "./App.css";

function App() {
  // axios.defaults.baseURL = `http://localhost:5000/api/v1`;
  // axios.defaults.baseURL = `http://13.233.205.56:8080/api/v1`;
  // axios.defaults.baseURL = `http://15.206.84.115:8080/api/v1`;
  axios.defaults.baseURL = `https://clidex.io/api/v1/`;

  return <RouterIndex />;
}

export default App;
